import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '@assets/css/auth/login.css'

export default function LoginFailure() {
    const navigate = useNavigate();
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState('로그인에 실패했습니다.');

    console.log('-----LoginFailure');

    useEffect(() => {
        // URL 파라미터에서 에러 메시지 추출
        const searchParams = new URLSearchParams(location.search);
        const message = searchParams.get('message');
        const responseParam = searchParams.get('response');

        if (message) {
            setErrorMessage(decodeURIComponent(message));
        } else if (responseParam) {
            try {
                const response = JSON.parse(decodeURIComponent(responseParam));
                if (!response.success && response.message) {
                    setErrorMessage(response.message);
                }
            } catch (e) {
                console.error('응답 데이터 파싱 오류:', e);
            }
        }
    }, [location]);

    // 로그인 페이지로 이동
    const goToLogin = () => {
        navigate('/login');
    };

    return (
        <div className="login-failure-container">
            <div className="login-failure-card">
                <h2>로그인 실패</h2>
                <div className="error-icon">
                    <i className="fas fa-times-circle"></i>
                </div>
                <div className="error-message">
                    <p>{errorMessage}</p>
                </div>
                <div className="button-container">
                    <button onClick={goToLogin} className="login-button">
                        로그인 페이지로 이동
                    </button>
                </div>
            </div>
        </div>
    );
}